<template>
  <div class="waves-effect waves-light btn-flat period-selector-button" >
    <select v-model="model" class="browser-default period-selector">
      <option value="user_input" disabled>{{ $t('periodselection.user_input') }}</option>
      <option v-for="(label, key) in selectablePeriods" :value="key" :key="key" style="color: black;">
        {{ label }}
      </option>
    </select>
  </div>

</template>

<script>
export default {
  name: 'PeriodSelector',
  props: {
    value: {},
    periods: {}
  },
  data () {
    return {
      model: this.value,
      defaultPeriods: {
        '1week': this.$t('periodselection.last_week'),
        '2weeks': this.$t('periodselection.last_two_weeks'),
        '1month': this.$t('periodselection.last_month'),
        '3months': this.$t('periodselection.last_three_months'),
        '6months': this.$t('periodselection.last_six_months'),
        '1year': this.$t('periodselection.last_year')
      }
    }
  },
  computed: {
    selectablePeriods () {
      if (!this.periods) {
        return this.defaultPeriods
      }

      return this.periods
    }
  },
  watch: {
    value () {
      this.model = this.value
    },
    model () {
      this.$emit('input', this.model)
    }
  }
}
</script>

<style scoped>
.period-selector {
  color: deepskyblue;
  border: none;
  padding: 0 16px;
}

.period-selector-button {
  border: deepskyblue 1px solid;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  height: 2.5rem;
  padding: 0;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
}

.period-selector-button:hover {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
}

.period-selector:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PeriodSelector.vue